import { render, staticRenderFns } from "./ProductSets.vue?vue&type=template&id=498d9856&"
import script from "./ProductSets.vue?vue&type=script&lang=js&"
export * from "./ProductSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports